import React from 'react';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';

import HealthMonitorView from './HealthMonitorView';

import classes from './HealthPanel.module.css';

const HealthPanel = ({
    selectedNode,
    onToggleCreateServiceRequestModal
}) => {

    return (
        <Paper className={classes.HealthPanel}>
            <div className={classes.header}>
                <img src="assets/images/RingingAlarmFlat.svg" alt="" />
                <span>Health Monitor</span>
            </div>
            <div className={classes.subHeader}>
                {selectedNode.name}
            </div>
            <HealthMonitorView
                node={selectedNode}
                onToggleCreateServiceRequestModal={onToggleCreateServiceRequestModal}
            />
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        selectedNode: state.architect.selectedNode
    };
};

export default connect(mapStateToProps, null)(HealthPanel);
